<template>
  <div>
    <navlist :navlist="about" :show='false' />
    <div class="layout">
      <div class="title">
        <h1>
          社区
          <br />简介
        </h1>
        <h2>媒体报道</h2>
      </div>
      <div class="main">
        
        <h3 style="text-align:center; ">{{title}}</h3>
         <div v-html="content"></div>
      </div>
      
    </div>
  </div>
</template>

<script>
import news from "../../components/news";
import navlist from "../../components/nav";
import {getMediaContent} from '../../api/index'
export default {
  components: {
    navlist,
    news
  },
  data() {
    return {
       about: [
        {
          path: "/about/introduction",
          name: "社区图"
        },
        {
          path: "/about/honour",
          name: "社区荣誉"
        },
        {
          path: "/about/leader",
          name: "领导关怀"
        },
        {
          path: "/about/media",
          name: "媒体报道"
        }
      ],
   
      local: "",
      title:'',
      content:'',
      id: this.$route.params.detail
    };
  },
  created() {
    this.getContent()
  },
  methods: {
    async getContent(){
      let {id} =this
      let {data} = await getMediaContent(id)
      
      this.content = data.data.content
      this.title = data.data.title
    }
  }
};
</script>

<style>
.width {
  width: 1380px;
  margin-top: 20px !important;
}
</style>